// extracted by mini-css-extract-plugin
export var content = "gridTwoCol-module--content--12f90";
export var gray = "gridTwoCol-module--gray--f1778";
export var noBorder = "gridTwoCol-module--noBorder--dd2c3";
export var painted = "gridTwoCol-module--painted--4fdda";
export var split = "gridTwoCol-module--split--93623";
export var wide = "gridTwoCol-module--wide--1a69f";
export var wrapper = "gridTwoCol-module--wrapper--ea3c9";